module.exports = __webpack_public_path__ + "img/flag-icon-mys.10e626f0.svg";